"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearCache = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const ConfirmationDiaglog = __importStar(require("@genesys/client-core/lib/confirmation-dialog"));
const elements_1 = require("./elements");
const ClearCacheFieldSet = (0, styled_components_1.default)(elements_1.StyledFieldset) `
  p {
    margin: 10px 0;
    font-weight: bold;
  }

  table {
    margin-top: 10px;
    td {
      padding: 10px;
      vertical-align: middle;
    }
  }
`;
const clearCacheMutation = (0, graphql_tag_1.default) `
  mutation ClearCacheMutation {
    clearProductCache
  }
`;
class ClearCache extends React.Component {
    constructor(props) {
        super(props);
        this.clearCache = () => {
            this.setState(prevstate => ({
                servers: prevstate.servers.map(s => (Object.assign(Object.assign({}, s), { clearCacheServerState: {
                        type: "ClearCacheServerStateRunning"
                    } }))),
                confirmClearCache: false
            }));
            for (const server of this.state.servers) {
                GraphQLRequest.request(clearCacheMutation, {}, this.props.includeServerLog, server.url, this.props.clientConfigContextValue.authorization)
                    .then(_ => {
                    this.setState(prevState => (Object.assign(Object.assign({}, prevState), { servers: prevState.servers.map(s => {
                            if (s.url === server.url) {
                                return Object.assign(Object.assign({}, s), { clearCacheServerState: {
                                        type: "ClearCacheServerStateCompleted"
                                    } });
                            }
                            return s;
                        }) })));
                })
                    .catch(() => {
                    this.setState(prevState => (Object.assign(Object.assign({}, prevState), { servers: prevState.servers.map(s => {
                            if (s.url === server.url) {
                                return Object.assign(Object.assign({}, s), { clearCacheServerState: {
                                        type: "ClearCacheServerStateFailed"
                                    } });
                            }
                            return s;
                        }) })));
                });
            }
        };
        this.onClearCacheClick = () => {
            if (this.props.isProduction && !this.state.confirmClearCache) {
                this.setState(Object.assign(Object.assign({}, this.state), { confirmClearCache: true }));
            }
            else {
                this.clearCache();
            }
        };
        this.onClearCacheConfirm = () => {
            this.clearCache();
        };
        this.onClearCacheCancel = () => {
            this.setState(Object.assign(Object.assign({}, this.state), { confirmClearCache: false }));
        };
        const uniqueUrls = new Set(props.servers);
        this.state = {
            servers: Array.from(uniqueUrls.values()).map(url => ({
                url: url.replace(/\/$/, "") + "/graphql",
                clearCacheServerState: {
                    type: "ClearCacheServerStateNothing"
                }
            })),
            confirmClearCache: false
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(ConfirmationDiaglog.ConfirmationDialogPortal, { show: this.state.confirmClearCache, negativeText: "Cancel", positiveText: "Clear cache", onAbort: this.onClearCacheCancel, onConfirm: this.onClearCacheConfirm, text: "You are about to clear cache on production", title: "Alert" }),
            React.createElement(ClearCacheFieldSet, null,
                React.createElement("legend", null, "Clear cache"),
                React.createElement(Elements.StandardButton, { disabled: this.state.servers.some(s => s.clearCacheServerState.type === "ClearCacheServerStateRunning"), onClick: this.onClearCacheClick }, "Clear cache"),
                this.state.servers.every(s => s.clearCacheServerState.type === "ClearCacheServerStateCompleted") && (React.createElement("p", null,
                    "All caches cleared.",
                    " ",
                    React.createElement("a", { href: "javascript:window.location.reload(true)" }, "Click here to reload"))),
                React.createElement("table", null,
                    React.createElement("tbody", null, this.state.servers.map(s => (React.createElement(ServerRow, { key: s.url, url: s.url, clearCacheServerState: s.clearCacheServerState }))))))));
    }
}
exports.ClearCache = ClearCache;
function ServerRow({ clearCacheServerState, url }) {
    return (React.createElement("tr", null,
        React.createElement("td", null, url),
        (() => {
            switch (clearCacheServerState.type) {
                case "ClearCacheServerStateNothing": {
                    return React.createElement("td", null);
                }
                case "ClearCacheServerStateRunning": {
                    return (React.createElement("td", null,
                        React.createElement(Elements.MiniSpinner, { size: 12 })));
                }
                case "ClearCacheServerStateCompleted": {
                    return React.createElement("td", null, "Cache cleared");
                }
                case "ClearCacheServerStateFailed": {
                    return React.createElement("td", null, "Failed");
                }
                default: {
                    (0, ts_exhaustive_check_1.exhaustiveCheck)(clearCacheServerState);
                    return null;
                }
            }
        })()));
}
//# sourceMappingURL=clear-cache.js.map